 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~96e27529","1":"source~/esports-betting-rules-TR~bet-builder-rules-AZ~bet-builder-rules-DE~bet-builder-rules-EN~bet-~f18c8dae","2":"source~/esports-betting-rules-TR~esports-betting-rules-AZ~esports-betting-rules-DA~esports-betting-r~4f269f2f","3":"source~virtual-esports-betting-rules-AZ~virtual-esports-betting-rules-EN~virtual-esports-betting-rul~ea494b20","8":"source~i18n-widgets-az-json","9":"source~i18n-widgets-en-json","10":"source~i18n-widgets-ru-json","11":"source~i18n-widgets-tr-json","14":"source~/esports-betting-rules-TR","15":"source~bet-builder-rules-AZ","16":"source~bet-builder-rules-DE","17":"source~bet-builder-rules-EN","18":"source~bet-builder-rules-ES","19":"source~bet-builder-rules-ES-MX","20":"source~bet-builder-rules-ET","21":"source~bet-builder-rules-FI","22":"source~bet-builder-rules-FR","23":"source~bet-builder-rules-HE","24":"source~bet-builder-rules-IT","25":"source~bet-builder-rules-JA","26":"source~bet-builder-rules-KA","27":"source~bet-builder-rules-LT","28":"source~bet-builder-rules-LV","29":"source~bet-builder-rules-PL","30":"source~bet-builder-rules-PT-BR","31":"source~bet-builder-rules-RO","32":"source~bet-builder-rules-RU","33":"source~bet-builder-rules-SQ","34":"source~bet-builder-rules-SV","35":"source~bet-builder-rules-TR","36":"source~bet-details-page","37":"source~betting-history-container","38":"source~betting-history-page","39":"source~betting-rules-AZ","40":"source~betting-rules-DA","41":"source~betting-rules-DE","42":"source~betting-rules-EN","43":"source~betting-rules-ES","44":"source~betting-rules-ES-MX","45":"source~betting-rules-FI","46":"source~betting-rules-FR","47":"source~betting-rules-HE","48":"source~betting-rules-IT","49":"source~betting-rules-JA","50":"source~betting-rules-PL","51":"source~betting-rules-PT","52":"source~betting-rules-PT-BR","53":"source~betting-rules-RO","54":"source~betting-rules-RU","55":"source~betting-rules-SQ","56":"source~betting-rules-SV","57":"source~betting-rules-TR","58":"source~bonus-info","59":"source~cashout-terms-AR","60":"source~cashout-terms-AZ","61":"source~cashout-terms-DA","62":"source~cashout-terms-DE","63":"source~cashout-terms-EN","64":"source~cashout-terms-ES","65":"source~cashout-terms-ES-MX","66":"source~cashout-terms-ET","67":"source~cashout-terms-FI","68":"source~cashout-terms-FR","69":"source~cashout-terms-HE","70":"source~cashout-terms-IT","71":"source~cashout-terms-JA","72":"source~cashout-terms-KA","73":"source~cashout-terms-KU","74":"source~cashout-terms-LT","75":"source~cashout-terms-LV","76":"source~cashout-terms-PL","77":"source~cashout-terms-PT","78":"source~cashout-terms-PT-BR","79":"source~cashout-terms-RO","80":"source~cashout-terms-RU","81":"source~cashout-terms-SQ","82":"source~cashout-terms-SR","83":"source~cashout-terms-SV","84":"source~cashout-terms-TR","85":"source~esports-betting-rules-AZ","86":"source~esports-betting-rules-DA","87":"source~esports-betting-rules-DE","88":"source~esports-betting-rules-EN","89":"source~esports-betting-rules-ES","90":"source~esports-betting-rules-ES-MX","91":"source~esports-betting-rules-ET","92":"source~esports-betting-rules-FI","93":"source~esports-betting-rules-FR","94":"source~esports-betting-rules-HE","95":"source~esports-betting-rules-IT","96":"source~esports-betting-rules-JA","97":"source~esports-betting-rules-KA","98":"source~esports-betting-rules-LT","99":"source~esports-betting-rules-LV","100":"source~esports-betting-rules-PL","101":"source~esports-betting-rules-PT","102":"source~esports-betting-rules-PT-BR","103":"source~esports-betting-rules-RO","104":"source~esports-betting-rules-RU","105":"source~esports-betting-rules-SQ","106":"source~esports-betting-rules-SR","107":"source~esports-betting-rules-SV","109":"source~generated-mappings","110":"source~i18n-az-json","111":"source~i18n-en-json","112":"source~i18n-ru-json","113":"source~i18n-tr-json","115":"source~settings-page","116":"source~streaming-carousel","117":"source~virtual-esports-betting-rules-AZ","118":"source~virtual-esports-betting-rules-EN","119":"source~virtual-esports-betting-rules-HE","120":"source~virtual-esports-betting-rules-IT","121":"source~virtual-esports-betting-rules-JA","122":"source~virtual-esports-betting-rules-PL","123":"source~virtual-esports-betting-rules-RU","125":"vendors~rc-slider","126":"vendors~react-google-recaptcha","127":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"bc8f241c87db186608ae","1":"48248f4869b0812d7a05","2":"c5436dea5e7c04909fef","3":"68e030ed29f08e6eb414","4":"85dc40d0ffdc9bb6b0aa","5":"fe7f2f6bc6aa2b3b08e1","6":"998fb041d4959cbc22d3","8":"b33f8e8951565c992902","9":"0a744f05fd7e131ca33f","10":"6bce9fba1cf26d93a9d5","11":"676c4438052c8140554c","14":"fc7ee28a75962d27ab31","15":"b80eb666c740ae5472d0","16":"f9906ef8ee20c06e9034","17":"c686022a06f0d3674166","18":"002add04963c5c859d70","19":"7e171a088bf303b36407","20":"21f286822955a7e87b3c","21":"2b02bb5fe304d7bb1a26","22":"d506af5ffa9662844fa9","23":"29a2d4e65c8d20f0245e","24":"c560a4ab1d0fd3801d70","25":"93acf57da1411c8044df","26":"e8e2bcb05362225f39dc","27":"372914bdb908ebc9df44","28":"a5290b68a8e5ef53bb2d","29":"2ae98053ba454f5b87b0","30":"2489b73324e36eeab215","31":"5adefe4b5d94429a8832","32":"54a9b55c8ba3f9682c80","33":"27abdc95533f64a6904b","34":"8e998fba24655a55ffd2","35":"b5f43c1ec48b512cb3c7","36":"906c328946cb0d631484","37":"6b7d321cac274dbedba5","38":"b6f89044a814961bb752","39":"d6d92a3d4d8fdbe3a5fe","40":"bb0198bceebe8794e1da","41":"e485f09cef34bfc31a0c","42":"9f23a52429d5f48ea794","43":"711ebf87dc81f0551d5b","44":"753bd7475fc9c4a7ebcf","45":"ff858a6604c2aa07351a","46":"0ed529f81303bdbd0182","47":"6491763a5daa1ed4545f","48":"2bf5a1eff398e986e1a5","49":"e728ceee339b295057cd","50":"f360fbc2ae02ce85b6b9","51":"bfe8a1d84b4f28a24630","52":"b65f1daab94b59ba913e","53":"43d27a06cb56712801e0","54":"905e76fb0654f02db148","55":"12d51654b4318c45d23d","56":"33c5963a850575537f0e","57":"4d554b51aaeb70d9b898","58":"cf511d6af123e039e263","59":"a8cdcb5d3f2ff2184219","60":"775cdc36fa0ebce87bf5","61":"ea8396e423c870a08596","62":"feae4d018cfde3f7bd5b","63":"17c037d53bb4d2477c99","64":"e26f1da446df09e398bf","65":"69552e0e818a0c3e2f73","66":"8f69f1c89c322493727f","67":"a220c999acc7c739dccf","68":"f33a4b9a8fe77dc13f7b","69":"d6064d5ba228af13aba2","70":"661660463fe3508ec41f","71":"fa7ebc929b47847df274","72":"cf396a82d9811f969082","73":"35412cda8ace74dda022","74":"b769b4baf8a29b67217f","75":"f05efb4dba282d313fd5","76":"b8bee7b42fac77890e33","77":"d2213244b0fb27cb2277","78":"a5eefe6a79cbcb0a9eb3","79":"e1c4125e826b66c9624a","80":"97607c8d7a4e0d232cd8","81":"23567d6f54a043775e1f","82":"a4ccf6d8e6cf99d0a505","83":"6dfd5c25f405cf4aa17d","84":"4ca36a8f019a63e8ced2","85":"97161ffca509fc171bd3","86":"42faf351b4f718346c5e","87":"c227f8cae5a999fbab5c","88":"3b8012d2aaec7bc6d141","89":"fb1e5426bd2acd4fa682","90":"049f81d5e962280725b3","91":"8cb32b6ab7c97b8fe23b","92":"fcacc4f1f9c3d75d0eba","93":"cb30f9cd4cddce3b586e","94":"9247d6664c900a8fa264","95":"975d35a367c49812d481","96":"9222be6a81a8648b90b1","97":"86bcc32e72dea05bbd57","98":"f777cfd68633f63d6f71","99":"ecd0d7b471494d9b288b","100":"e0d3ffd5d136b23eb3c5","101":"0333fe7250fc17eb586a","102":"ec53d25f4ba16449e758","103":"733d23893dd71aea2145","104":"2554eff0c5ef8ba28c4c","105":"1e606b2b4d8e23d894e8","106":"2a175687e1bbba006b97","107":"28aa792a9eb6505c2082","109":"31ac86a7f947dd127a17","110":"288cc4be6aad9bed14f5","111":"f201991538e677545bbf","112":"e82871f1c75f506e0aa2","113":"dd1274fa8a4ff35e8f7d","115":"c21e98d41d9d397295e2","116":"c538f208a738295462ed","117":"30d3c58e3ab5eff974a6","118":"31a547b0cd58192905d4","119":"86cbcd236e0591114d85","120":"75b8c6087e9b6c2fe59f","121":"353f8fe9612f2e5695c9","122":"d860fa5bbd40b990243b","123":"dd9496f6d87d48269f03","125":"e4088fd202a916e9879b","126":"52d6f9abdd87693f4bcd","127":"ad1f9e009c7accc0b0aa","128":"07dbefb6252d07d42597","129":"70e9d1632634b391cf57","130":"7d430265e9976e878b5d","131":"e695f824eed5de0474ce","132":"99184732b262cbe57c1f","133":"5bc437e3290a4635e4db","134":"a80091efae490e7d2e9f","135":"567e59cd6a9cbdf9dc4e","136":"915b1e537d9148c95d9d","137":"796df26bf63321a84ec9","138":"c9ad10bc8f0619e5ef93","139":"0d1f39f8aa4bed8dfe92","140":"2d1ba3d033421acdf20d","141":"eaa7c0f9f5f9e2263a3d","142":"5f9fb9128c0360afa805","143":"c4bd9d30aa978fc54fa0","144":"eb2ed1faac2a66870a1c","145":"761a2fc2e6ea51c6b0c5","146":"13af2269256070122fb8","147":"bf348c36664f6c4cb4dd","148":"d29b28412418ba904ca0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
